// pages/EdicaoCliente.jsx
import React, { useEffect, useState } from "react";
import CadastroCliente from "./CadastroCliente";
import { useParams, useNavigate } from "react-router-dom";

const EdicaoCliente = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [cliente, setCliente] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const fetchCliente = async () => {
      try {
        const response = await fetch(`http://localhost:5000/api/clientes/${id}`);
        const data = await response.json();
        if (response.ok) {
          setCliente(data);
        } else {
          alert("Cliente não encontrado.");
          navigate("/clientes"); // ou a rota da listagem
        }
      } catch (error) {
        console.error("Erro ao buscar cliente:", error);
        alert("Erro ao carregar dados do cliente.");
        navigate("/clientes");
      } finally {
        setCarregando(false);
      }
    };

    fetchCliente();
  }, [id, navigate]);

  if (carregando) return <p>Carregando dados...</p>;

  return (
    <div>
      <h2 className="form-title">Editar Cliente</h2>
      <CadastroCliente modoEdicao={true} dadosIniciais={cliente} />
    </div>
  );
};

export default EdicaoCliente;
